import React, { useState } from 'react';
import { DataTable } from '../components/DataTable';
import { WizardForm } from '../components/WizardForm';
import { StatusBadge } from '../components/StatusBadge';
export function OrganizationManagement() {
  const [activeTab, setActiveTab] = useState<'list' | 'add'>('list');
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    orgName: '',
    businessType: '',
    country: '',
    website: '',
    address: '',
    contactName: '',
    phone: '',
    mobile: '',
    email: '',
    authName: '',
    authDesignation: '',
    authEmail: '',
    authPhone: '',
    bankName: '',
    branchName: '',
    accountName: '',
    accountNumber: '',
    routingNumber: '',
    legalDocs: ''
  });
  const organizations = [{
    orgName: 'Sundarban Fisheries Ltd',
    email: 'info@sundarbanfish.com',
    idNumber: 'ORG-001',
    phone: '01711001122',
    businessType: 'Fisheries',
    status: 'approved' as const
  }, {
    orgName: 'Bay of Bengal Trading Co.',
    email: 'contact@bobtrade.com',
    idNumber: 'ORG-002',
    phone: '01811223344',
    businessType: 'Trading',
    status: 'approved' as const
  }, {
    orgName: 'Khulna Honey Producers',
    email: 'khp@gmail.com',
    idNumber: 'ORG-003',
    phone: '01911334455',
    businessType: 'Honey Production',
    status: 'approved' as const
  }, {
    orgName: 'Mongla Port Services',
    email: 'mps@mongla.com',
    idNumber: 'ORG-004',
    phone: '01611445566',
    businessType: 'Port Services',
    status: 'pending' as const
  }, {
    orgName: 'Satkhira Wood Industries',
    email: 'swi@satkhira.com',
    idNumber: 'ORG-005',
    phone: '01511556677',
    businessType: 'Wood Processing',
    status: 'approved' as const
  }];
  const columns = [{
    key: 'orgName',
    label: 'Organization Name'
  }, {
    key: 'email',
    label: 'Email ID'
  }, {
    key: 'idNumber',
    label: 'ID Number'
  }, {
    key: 'phone',
    label: 'Phone Number'
  }, {
    key: 'businessType',
    label: 'Business Type'
  }, {
    key: 'status',
    label: 'Status',
    render: (value: string) => <StatusBadge status={value as any} data-id="element-1272" />
  }];
  const filters = [{
    key: 'businessType',
    label: 'Business Type',
    options: ['Fisheries', 'Trading', 'Honey Production', 'Port Services', 'Wood Processing']
  }, {
    key: 'status',
    label: 'Status',
    options: ['Approved', 'Pending', 'Rejected']
  }];
  const wizardSteps = [{
    title: 'Organization Info',
    description: 'Enter basic organization details'
  }, {
    title: 'Contact Info',
    description: 'Enter contact and authorized person details'
  }, {
    title: 'Bank Details',
    description: 'Enter banking information'
  }, {
    title: 'Documents',
    description: 'Upload legal documents'
  }, {
    title: 'Review & Submit',
    description: 'Review all information before submitting'
  }];
  return <div className="space-y-6" data-id="element-1273">
      <div data-id="element-1274">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1275">
          Organization Management
        </h1>
        <p className="text-sm text-gray-600 mt-1" data-id="element-1276">
          Manage registered organizations and companies
        </p>
      </div>

      <div className="border-b border-gray-200" data-id="element-1277">
        <div className="flex gap-4" data-id="element-1278">
          <button onClick={() => setActiveTab('list')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'list' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-1279">
            Organization List
          </button>
          <button onClick={() => setActiveTab('add')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'add' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-1280">
            Add Organization
          </button>
        </div>
      </div>

      {activeTab === 'list' && <DataTable columns={columns} data={organizations} filters={filters} onView={row => console.log('View', row)} onEdit={row => console.log('Edit', row)} onDelete={row => console.log('Delete', row)} searchPlaceholder="Search organizations..." data-id="element-1281" />}

      {activeTab === 'add' && <WizardForm steps={wizardSteps} currentStep={currentStep} onStepChange={setCurrentStep} onSubmit={() => {
      if (!formData.orgName || !formData.businessType) {
        alert('Please fill in all required fields.');
        return;
      }
      alert(`Organization ${formData.orgName} registered successfully!`);
      setCurrentStep(0);
      setActiveTab('list');
      setFormData({
        orgName: '',
        businessType: '',
        country: '',
        website: '',
        address: '',
        contactName: '',
        phone: '',
        mobile: '',
        email: '',
        authName: '',
        authDesignation: '',
        authEmail: '',
        authPhone: '',
        bankName: '',
        branchName: '',
        accountName: '',
        accountNumber: '',
        routingNumber: '',
        legalDocs: ''
      });
    }} data-id="element-1282">
          {currentStep === 0 && <div className="space-y-4" data-id="element-1283">
              <div className="grid grid-cols-2 gap-4" data-id="element-1284">
                <div data-id="element-1285">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1286">
                    Organization Name *
                  </label>
                  <input type="text" required value={formData.orgName} onChange={e => setFormData({
              ...formData,
              orgName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1287" />
                </div>
                <div data-id="element-1288">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1289">
                    Business Type *
                  </label>
                  <select required value={formData.businessType} onChange={e => setFormData({
              ...formData,
              businessType: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1290">
                    <option value="" data-id="element-1291">Select Type</option>
                    <option value="Fisheries" data-id="element-1292">Fisheries</option>
                    <option value="Trading" data-id="element-1293">Trading</option>
                    <option value="Honey Production" data-id="element-1294">Honey Production</option>
                    <option value="Port Services" data-id="element-1295">Port Services</option>
                    <option value="Wood Processing" data-id="element-1296">Wood Processing</option>
                    <option value="Other" data-id="element-1297">Other</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1298">
                <div data-id="element-1299">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1300">
                    Business Operation Country
                  </label>
                  <input type="text" value={formData.country} onChange={e => setFormData({
              ...formData,
              country: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1301" />
                </div>
                <div data-id="element-1302">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1303">
                    Website
                  </label>
                  <input type="url" value={formData.website} onChange={e => setFormData({
              ...formData,
              website: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1304" />
                </div>
              </div>
              <div data-id="element-1305">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1306">
                  Communication Address
                </label>
                <textarea rows={3} value={formData.address} onChange={e => setFormData({
            ...formData,
            address: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1307" />
              </div>
            </div>}

          {currentStep === 1 && <div className="space-y-6" data-id="element-1308">
              <div data-id="element-1309">
                <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1310">
                  Primary Contact
                </h3>
                <div className="grid grid-cols-2 gap-4" data-id="element-1311">
                  <div data-id="element-1312">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1313">
                      Contact Person Name
                    </label>
                    <input type="text" value={formData.contactName} onChange={e => setFormData({
                ...formData,
                contactName: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1314" />
                  </div>
                  <div data-id="element-1315">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1316">
                      Email
                    </label>
                    <input type="email" value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1317" />
                  </div>
                  <div data-id="element-1318">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1319">
                      Phone
                    </label>
                    <input type="tel" value={formData.phone} onChange={e => setFormData({
                ...formData,
                phone: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1320" />
                  </div>
                  <div data-id="element-1321">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1322">
                      Mobile
                    </label>
                    <input type="tel" value={formData.mobile} onChange={e => setFormData({
                ...formData,
                mobile: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1323" />
                  </div>
                </div>
              </div>

              <div className="pt-4 border-t border-gray-200" data-id="element-1324">
                <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1325">
                  Authorized Person
                </h3>
                <div className="grid grid-cols-2 gap-4" data-id="element-1326">
                  <div data-id="element-1327">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1328">
                      Authorized Person Name
                    </label>
                    <input type="text" value={formData.authName} onChange={e => setFormData({
                ...formData,
                authName: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1329" />
                  </div>
                  <div data-id="element-1330">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1331">
                      Designation
                    </label>
                    <input type="text" value={formData.authDesignation} onChange={e => setFormData({
                ...formData,
                authDesignation: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1332" />
                  </div>
                  <div data-id="element-1333">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1334">
                      Authorized Email
                    </label>
                    <input type="email" value={formData.authEmail} onChange={e => setFormData({
                ...formData,
                authEmail: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1335" />
                  </div>
                  <div data-id="element-1336">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1337">
                      Authorized Phone/Mobile
                    </label>
                    <input type="tel" value={formData.authPhone} onChange={e => setFormData({
                ...formData,
                authPhone: e.target.value
              })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1338" />
                  </div>
                </div>
              </div>
            </div>}

          {currentStep === 2 && <div className="space-y-4" data-id="element-1339">
              <div className="grid grid-cols-2 gap-4" data-id="element-1340">
                <div data-id="element-1341">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1342">
                    Bank Name
                  </label>
                  <input type="text" value={formData.bankName} onChange={e => setFormData({
              ...formData,
              bankName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1343" />
                </div>
                <div data-id="element-1344">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1345">
                    Branch Name
                  </label>
                  <input type="text" value={formData.branchName} onChange={e => setFormData({
              ...formData,
              branchName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1346" />
                </div>
                <div data-id="element-1347">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1348">
                    Account Name
                  </label>
                  <input type="text" value={formData.accountName} onChange={e => setFormData({
              ...formData,
              accountName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1349" />
                </div>
                <div data-id="element-1350">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1351">
                    Account Number
                  </label>
                  <input type="text" value={formData.accountNumber} onChange={e => setFormData({
              ...formData,
              accountNumber: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1352" />
                </div>
                <div data-id="element-1353">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1354">
                    Routing Number
                  </label>
                  <input type="text" value={formData.routingNumber} onChange={e => setFormData({
              ...formData,
              routingNumber: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1355" />
                </div>
              </div>
            </div>}

          {currentStep === 3 && <div className="space-y-4" data-id="element-1356">
              <div data-id="element-1357">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1358">
                  Legal Documents *
                </label>
                <input type="file" accept="image/*,application/pdf" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1359" />
                <p className="text-xs text-gray-500 mt-1" data-id="element-1360">
                  Upload Trade License, TIN, BIN, etc. (PDF or Image)
                </p>
              </div>
            </div>}

          {currentStep === 4 && <div className="space-y-6" data-id="element-1361">
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-1362">
                <div className="flex items-center justify-between mb-3" data-id="element-1363">
                  <h4 className="font-semibold text-gray-900" data-id="element-1364">
                    Organization Information
                  </h4>
                  <button onClick={() => setCurrentStep(0)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-1365">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-1366">
                  <div data-id="element-1367">
                    <span className="text-gray-600" data-id="element-1368">Name:</span>{' '}
                    <span className="font-medium" data-id="element-1369">
                      {formData.orgName || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1370">
                    <span className="text-gray-600" data-id="element-1371">Business Type:</span>{' '}
                    <span className="font-medium" data-id="element-1372">
                      {formData.businessType || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1373">
                    <span className="text-gray-600" data-id="element-1374">Country:</span>{' '}
                    <span className="font-medium" data-id="element-1375">
                      {formData.country || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-1376">
                <div className="flex items-center justify-between mb-3" data-id="element-1377">
                  <h4 className="font-semibold text-gray-900" data-id="element-1378">Contact Info</h4>
                  <button onClick={() => setCurrentStep(1)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-1379">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-1380">
                  <div data-id="element-1381">
                    <span className="text-gray-600" data-id="element-1382">Contact Person:</span>{' '}
                    <span className="font-medium" data-id="element-1383">
                      {formData.contactName || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1384">
                    <span className="text-gray-600" data-id="element-1385">Email:</span>{' '}
                    <span className="font-medium" data-id="element-1386">
                      {formData.email || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1387">
                    <span className="text-gray-600" data-id="element-1388">Authorized Person:</span>{' '}
                    <span className="font-medium" data-id="element-1389">
                      {formData.authName || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-1390">
                <div className="flex items-center justify-between mb-3" data-id="element-1391">
                  <h4 className="font-semibold text-gray-900" data-id="element-1392">Bank Details</h4>
                  <button onClick={() => setCurrentStep(2)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-1393">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-1394">
                  <div data-id="element-1395">
                    <span className="text-gray-600" data-id="element-1396">Bank Name:</span>{' '}
                    <span className="font-medium" data-id="element-1397">
                      {formData.bankName || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1398">
                    <span className="text-gray-600" data-id="element-1399">Account No:</span>{' '}
                    <span className="font-medium" data-id="element-1400">
                      {formData.accountNumber || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>
            </div>}
        </WizardForm>}
    </div>;
}